import { LiFiWidget, WidgetConfig, WidgetDrawer } from "@lifi/widget";
import Button from "app/components/button/button";
import { useTheme } from "app/shared";
import { getFeeByTier } from "app/utils/getFeeByTier";
import { FC, useRef, useMemo } from "react";

interface ILiFi {
  variant: "drawer" | "compact";
  integrator: string;
  tier?: string;
}

export const LiFi: FC<ILiFi> = ({ variant, integrator, tier }) => {
  const drawerRef = useRef<WidgetDrawer>(null);
  const { theme } = useTheme();

  const config: WidgetConfig = useMemo(
    () => ({
      integrator: integrator,
      fee: getFeeByTier(tier),
      hiddenUI: ["poweredBy"],
      variant: variant,
      theme: {
        palette: {
          primary: { main: "#E90092" },
          secondary: { main: "#E90092" },
          background: {
            default: theme === "light" ? "#ffffff" : "#391368",
            paper: theme === "light" ? "#f8f8fa" : "#522f7d",
          },
          text: {
            primary: theme === "light" ? "#00070F" : "#ffffff",
            secondary: theme === "light" ? "#6A7481" : "#ffffffae",
          },
        },
        shape: {
          borderRadius: 10,
          borderRadiusSecondary: 8,
        },
        typography: {
          fontFamily: "Montserrat",
        },
        container: {
          padding: 20,
          ...(variant === "compact" && {
            borderRadius: 40,
            width: "100%",
            maxWidth: "100%",
          }),
        },
      },
    }),
    [variant, integrator, tier, theme]
  );

  const toggleWidget = () => {
    drawerRef.current?.toggleDrawer();
  };

  if (variant === "drawer") {
    return (
      <div>
        <Button variant="outlined" onClick={toggleWidget}>
          Onchain Swap
        </Button>
        <LiFiWidget ref={drawerRef} config={config} integrator={integrator} />
      </div>
    );
  }

  return <LiFiWidget config={config} integrator={integrator} />;
};
